import styled from 'styled-components';
import { Input } from 'antd';
const { TextArea } = Input;
export const ReportModalContentContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
`;

export const ReportModalHeader = styled.div`
  display: flex;
  justify-content: center;
  font-size: 24px;
  font-weight: 500;
  line-height: 1.21;
  color: #1d1e2b;
  margin-bottom: 30px;
`;
export const ModalContent = styled.div`
  font-size: 14px;
  font-weight: 500;
  line-height: 1.43;
  text-align: left;
  color: #73747d;
  width: 100%;
  display: flex;
  justify-content: center;
`;

export const StyledTextArea = styled(TextArea)`
  border-radius: 4px;
  border: solid 1px #e3e7ed;
`;

export const ReportModalButtons = styled.div`
  margin-top: 40px;
  margin-bottom: 40px;
`;
